import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import AssessmentBlock from '../AssessmentBlock';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';

var TeacherAssessmentBlock = /*#__PURE__*/function (_AssessmentBlock) {
  _inherits(TeacherAssessmentBlock, _AssessmentBlock);

  var _super = _createSuper(TeacherAssessmentBlock);

  function TeacherAssessmentBlock(props) {
    var _this;

    _classCallCheck(this, TeacherAssessmentBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "editorBlockWasAdded", function () {
      var editor = _this.api.getEditor();

      var translate = editor.getProp('translate');
      var editMode = false;

      if (_this.resources.length == 0) {
        setTimeout(function () {
          _this.addResource('assessmenttype', {
            '@odata.type': 'assessmenttype',
            'value': ASSESSMENT_TYPES.TEACHER
          });

          _this.addResource(_this.PART_RESOURCE_TYPE, {
            status: 'Started',
            referenceId: '0',
            referenceType: 'assessmentonlyfeedback',
            assessmentBlockPartRows: [],
            value: null,
            permissions: [{
              referenceType: 'ASSESSMENTFEEDBACK',
              target: 'GUARDIAN',
              level: 'READ'
            }, {
              referenceType: 'ASSESSMENTFEEDBACK',
              target: 'STUDENT',
              level: 'READ'
            }]
          });
        }, 500);
      }

      var teacherAssessments = editor.getBlocks().filter(function (block) {
        return block.assessmentType == ASSESSMENT_TYPES.TEACHER;
      });
      editor.getBlocks().forEach(function (block) {
        var _block$resources;

        editMode = ((_block$resources = block.resources) === null || _block$resources === void 0 ? void 0 : _block$resources.length) > 0 && block.resources.every(function (s) {
          return s.id != null && s.id > 0;
        });
      });

      if (editMode) {
        var foundIndex = teacherAssessments.findIndex(function (b) {
          return b.field == _this.field;
        });

        _this.events.onTitleChange(translate('Teacher assessment') + ' ' + (foundIndex + 1));
      } else {
        _this.events.onTitleChange(translate('Teacher assessment') + ' ' + teacherAssessments.length);
      }

      var disableRows = editor.getProp('disableRows');

      if (disableRows != null && disableRows.length > 0 && _this.resources != null) {
        var disabled = _this.getResources().find(function (resource) {
          var _resource$assessmentB;

          return ((_resource$assessmentB = resource.assessmentBlockPartRows) === null || _resource$assessmentB === void 0 ? void 0 : _resource$assessmentB.findIndex(function (row) {
            return disableRows.includes(row.id);
          })) > -1;
        }) != null;

        if (disabled) {
          _this.api.deregisterAction('Remove');
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addGoalMatrix", function (event) {
      event.preventDefault();

      _this.removeFeedBackOnlyResource();

      _this.addResource(_this.PART_RESOURCE_TYPE, {
        status: 'Started',
        referenceId: '',
        referenceType: 'assessmentGoal',
        value: {
          id: 0,
          visibleToStudent: true,
          visibleToGuardian: true,
          title: '',
          rows: []
        },
        permissions: [{
          referenceType: 'ASSESSMENTBLOCKPART',
          target: 'STUDENT',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTBLOCKPART',
          target: 'GUARDIAN',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'GUARDIAN',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'STUDENT',
          level: 'READ'
        }]
      });
    });

    _this.name = 'Haldor.Blocks.AssessmentBlock';
    _this.block_type = 'expandable_block';
    _this.assessmentType = ASSESSMENT_TYPES.TEACHER;
    return _this;
  }

  return _createClass(TeacherAssessmentBlock);
}(AssessmentBlock);

export default TeacherAssessmentBlock;